// extracted by mini-css-extract-plugin
export default {"root":"lh1PObx6RD7Os71oZUuH"};